import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalDocumentsByManager {
  name: string;
  api_token: string;
}

export interface InternalDocumentsByManagerListInfor {
  errors: unknown;
  internalDocumentsByManager: InternalDocumentsByManager;
  isAuthenticated: boolean;
}

@Module
export default class InternalDocumentsByManagerModule
  extends VuexModule
  implements InternalDocumentsByManagerListInfor
{
  errors = {};
  internalDocumentsByManager = {} as InternalDocumentsByManager;
  isAuthenticated = !!JwtService.getToken();

  get InternalDocumentsByManager() {
    return this.internalDocumentByManagerListData;
  }

  @Mutation
  [Mutations.INTERNAL_DOCUMENTS_BY_MANAGER_LIST_DATA](
    InternalDocumentsByManager
  ) {
    this.internalDocumentByManagerListData = InternalDocumentsByManager;
  }

  @Action
  [Actions.INTERNAL_DOCUMENTS_BY_MANAGER_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/internal/vanbannoibo", payload)
        .then((data) => {
          this.context.commit(
            Mutations.INTERNAL_DOCUMENTS_BY_MANAGER_LIST_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
